import { type AltoIconName, type ColorVariant } from '@alto/design-library-tokens';
import React from 'react';
import { getBrand } from '../../../utils/getBrand';
import { AltoIcon } from './AltoIcon';
import { FuzeHealthIcon } from './FuzeHealthIcon.web';

type IconProps = {
  readonly name: AltoIconName;
  readonly accessibilityLabel?: string;
  readonly allowFontScaling?: boolean;
  readonly type?: ColorVariant;
  readonly testID?: string;
};

/**
 * Resolves the correct icon based on the brand
 */
export const Icon = ({ name, accessibilityLabel, type, allowFontScaling = true, testID }: IconProps) => {
  const brand = getBrand();

  // Fuze Health icons only support web
  if (brand === 'fuzehealth') {
    return (
      <FuzeHealthIcon
        name={name}
        accessibilityLabel={accessibilityLabel}
        type={type}
        allowFontScaling={allowFontScaling}
        testID={testID}
      />
    );
  }

  // Alto icons support both web and native.
  // TODO: FuzeRx temporarily uses Alto icons until its own icons are ready
  // https://altopharmacy.atlassian.net/browse/PH-4161
  if (brand === 'alto' || brand === 'fuzerx') {
    return (
      <AltoIcon
        name={name}
        accessibilityLabel={accessibilityLabel}
        type={type}
        allowFontScaling={allowFontScaling}
        testID={testID}
      />
    );
  }

  throw new Error('Unable to resolve brand');
};
